import * as moment from "moment";
import * as qs from 'query-string';
import { IDashListSummary, DashRegistrationApi, IDashSearch, DashIntakeStatus, DashSearchDateType } from "@nkr/models/dash"
import { useFilteredSearch } from "@nkr/utils/rest-api/useFilteredSearch";
import { SearchIntendedRecipientFilter } from "../page-components/search-intended-recipient-filter";
import { SearchIntendedRecipientGrid } from "../page-components/search-intended-recipient-grid";
import { SearchIntendedRecipientSidebar } from "../page-components/search-intended-recipient-sidebar";
import { useAppHookContext } from '@nkr/utils/rest-api';
import { OrganType } from '@nkr/enums/organ-type';

export const SearchIntendedRecipient = () => {
    const { app: { site } } = useAppHookContext();

    const parsed = qs.parse(typeof window !== 'undefined' ? window.location.search : '');
    const msId = parsed['micrositeRecipientId'];

    const defaultSearch: IDashSearch = {
        filterStartDate: moment().subtract(1, 'months').format('YYYY-MM-DD'),
        filterEndDate: moment().format('YYYY-MM-DD'),

        includeRemote: true,
        dateSearchType: msId > 0 ? null : DashSearchDateType.IntakeCompleteDate,
        intakeStatuses: msId > 0
            ? [DashIntakeStatus.Incomplete, DashIntakeStatus.Referred, DashIntakeStatus.Donated, DashIntakeStatus.RuledOut]
            : [DashIntakeStatus.Referred, DashIntakeStatus.Donated],
        isRemote: msId > 0 ? null : true,
        organType: site.organType == OrganType.Kidney ? null : OrganType.Liver
    };

    const search = useFilteredSearch<IDashSearch, IDashListSummary>(DashRegistrationApi, defaultSearch);

    return (
        <div>
            <SearchIntendedRecipientFilter search={search} />
            <SearchIntendedRecipientGrid search={search} />

            {search.params.selectedRowId > 0 && <SearchIntendedRecipientSidebar search={search} />}
        </div>
    );
};